import { DocumentFieldStatus, LocationStatus } from '@sib/api';

const sharedNeutralMuted = 'bg-muted text-muted-foreground';

export const documentFieldStatusTableBadgeClass: Record<
  DocumentFieldStatus,
  string
> = {
  [DocumentFieldStatus.COMPLETE]: 'bg-success-soft text-success-foreground',
  [DocumentFieldStatus.MISSING_FIELDS]: 'bg-accent-pink-soft text-accent-pink',
  [DocumentFieldStatus.UPLOAD_INVOICES]:
    'bg-warning-soft text-warning-foreground',
  [DocumentFieldStatus.NOT_APPLICABLE]: 'bg-info-soft text-primary',
  [DocumentFieldStatus.NOT_APPLICABLE_REQUESTED]: 'bg-info-soft text-primary',
};

export const locationStatusTableBadgeClass: Record<LocationStatus, string> = {
  [LocationStatus.Active]: 'bg-success-soft text-success-foreground',
  [LocationStatus.Monitored]: 'bg-info-soft text-primary',
  [LocationStatus.Sold]: sharedNeutralMuted,
  [LocationStatus.Closed]: sharedNeutralMuted,
  [LocationStatus.UnderConstruction]: 'bg-warning-soft text-warning-foreground',
  [LocationStatus.NotActive]: 'bg-accent-pink-soft text-accent-pink',
};
